<template>
    <div class="">
        <AddZeroReport v-model="addZeroReportModal" :start-date="props.startDate" @dismiss="handleModalDismiss"></AddZeroReport>
        <CreateEditDeath ref="createEditDeathRef" v-model="createEditModal" :id="selectedDeath" :startDate="props.startDate" :currentState="props.currentState" @dismiss="handleModalDismiss"></CreateEditDeath>        
            <b-grid
                caption="List of deaths"
                :tableOptions="dcraEditTableOptions"
                :filterableFields="dcraStore.addEditFilterableFields"
                :filterOptions="dcraStore.addEditFilterOptions"
                @optionChange="fetchdata"
                :items="dcraData"
                :columns="dcraStore.AddEditColumns"
                :loading="dcraStore.loading"
                :current-item-count="numberOfReturnedItems">
                <template #pagingStart>
                    <div
                        class="btn-group"
                        role="group">
                        <button class="btn btn-primary" type="button" @click.prevent="handleNewEntryClick()">Add New Death</button> 
                    </div>
                    <div
                        class="btn-group"
                        role="group">
                        <button class="btn btn-primary" type="button" @click.prevent="handleNewZeroReportClick()">Add Zero Report</button> 
                    </div>
                </template>
                <template #cell.actions="{item}">
                    <button
                        type="button"
                        class="btn btn-primary"
                        v-on:click.prevent="handleEditEntryClick(item.id)">
                        Edit
                    </button>
                    <button
                        type="button"
                        class="btn btn-danger ms-2"
                        v-on:click.prevent="handleDeleteEntryClick(item)">
                        Delete
                    </button>
                </template>
            </b-grid> 
        <confirm-modal></confirm-modal>
    </div>    
</template>
<script setup lang="ts">

import {computed, ref, watch, onMounted} from "vue";

import BGrid from "./BGrid/BGrid.vue";
import { useDcraStore } from "@/stores/dcraStore";
import { useConfirmDialog } from "@/composable/useConfirmDialog";
import { Death } from "./DcraEditor/schema";
import CreateEditDeath from "./DcraEditor/CreateEditDeath.vue";
import ConfirmModal from "./Misc/ConfirmModal.vue";
import { BTableOptions } from "./BTable/BTable.types";
import AddZeroReport from "./DcraEditor/AddZeroReport.vue";

const {confirm} = useConfirmDialog();
const props = withDefaults(
    defineProps<{
        startDate: string;
        id?: string;
        ori?: string;
        currentState?:string;
    }>(),
    {
        startDate: "1900-01-01",
        id: '',
        ori: '',
        currentState: ""
    }
);

var selectedDeath = ref({} as number);
var createEditModal = ref(false);
var addZeroReportModal = ref(false);
const createEditDeathRef = ref<{ resetFormState: () => void } | null>(null);

const numberOfReturnedItems = ref(0);
var dcraEditTableOptions = ref({
        totalItemCount: 0,
        itemsPerPage: 25,
        page: 1,
        sortBy: [
            {
                key: "deathDate",
                isDescending: true,
            },
        ],
        pagingMode: "noTotal",
    } as BTableOptions);
    
// Stores
var dcraStore = useDcraStore();

// Computed properties
const dcraData = computed(() => dcraStore.listOfDeaths ?? []);

// Functions
const fetchdata = () => {
    dcraStore.fetchListOfDeaths(dcraEditTableOptions.value).then((returnData)=> {

        if (returnData.status == 200) {
            numberOfReturnedItems.value = returnData?.data?.data?.length ?? 0;
            if (returnData?.data?.data?.length > 0) {
                dcraStore.listOfDeaths = returnData.data.data.slice(0, dcraEditTableOptions.value.itemsPerPage);
            } else {
                dcraStore.listOfDeaths = returnData.data.data;
            }
    
            dcraEditTableOptions.value.totalItemCount = returnData.data.total;
        }
    });
}

const handleNewEntryClick = () => {
    var death = {} as Death;

    createEditDeathRef.value?.resetFormState();
    selectedDeath.value = death.id;
    createEditModal.value = true;
}

const handleNewZeroReportClick = () => {
    addZeroReportModal.value = true;
}

const handleEditEntryClick = (id:number) => {
    createEditDeathRef.value?.resetFormState();
    selectedDeath.value = id;
    createEditModal.value = true;
}

const handleDeleteEntryClick = async (death:Death) => {
    const shouldProceed = await confirm("Delete Confirmation", "Are You Sure?");
    if (shouldProceed) {
        dcraStore.deleteDeath(death.id);
        fetchdata();
    }
}

const handleModalDismiss = () => {
    createEditModal.value = false;
    addZeroReportModal.value = false;
}

//LifeCycle Hooks
onMounted(async ()=> {
    fetchdata();

    if(props.id != '' && props.ori != '') {
        let response = await dcraStore.getDeathIdByIncidentAndOri(props.id, props.ori);
        if (response) {
            handleEditEntryClick(response.data);
        }
    }
});

</script>